import Component from "react-pure-render/component";
import React from "react";
import { addNotificationsForInvalidFields } from "../lib/validationWeb";
import { Link } from "react-router";
import Table from "./table.react";

export default class Menus extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const {
      actions,
      menus: { menus: { meta } },
      notificationSystem
    } = this.props;
    actions.getMenus(meta).then(({ error, payload }) => {
      if (error) {
        addNotificationsForInvalidFields(payload, notificationSystem);
      }
    });
  }

  render() {
    const { menus: { menus: { entities: menus } } } = this.props;
    return (
      <div className="islogged-page">
        <div className="row middle-xs">
          <div className="col-xs-12">
            <div className="box-wrapper">
              <div className="title">Rodzaje menu</div>
              <div className="content-wrapper">
                <Table {...this.props} tableWidth={1000} tableHeight={300} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/menus/menus.react.js